import React from 'react';

export function number(className, bytes, precision, unit, raw) {
  if (isNaN(parseFloat(bytes)) || !isFinite(bytes) || bytes == 0) { return 0; }
  if (typeof precision === 'undefined') { precision = 0; }
  if (typeof unit === 'undefined') { unit = 'Bytes'; }

  const unit_s = unit.substr(0, 1);

  const units = [unit, `K${unit_s}`, `M${unit_s}`, `G${unit_s}`, `T${unit_s}`, `P${unit_s}`];
  const number = Math.floor(Math.log(bytes) / Math.log(1000));

  if (raw) {
    return (bytes / Math.pow(1000, Math.floor(number))).toFixed(precision) + units[number];
  }

  return (
    <div>
      <span>{(bytes / Math.pow(1000, Math.floor(number))).toFixed(precision)}</span>
      <span className={className}>{units[number]}</span>
    </div>
  );
}

export function price(p, currency) {
  if (typeof currency === 'undefined') { currency = '$'; }
  if (isNaN(parseFloat(p)) || !isFinite(p)) { return `<em>${currency}</em>${0}`; }

  p /= 100;
  p = p.toFixed(2).toString().split('.');

  return (
    <div>
      <em>{currency}</em>{+p[0]}<span>.{p[1]}</span>
    </div>
  );
}

export const obscureEmail = (email) => {
  const parts = email.split('@');
  const name = parts[0];
  let result = name.charAt(0);
  for (let i = 1; i < name.length; i++) {
    result += '*';
  }
  result += name.charAt(name.length - 1);
  result += '@';
  const domain = parts[1];
  result += domain.charAt(0);
  const dot = domain.indexOf('.');
  for (let i = 1; i < dot; i++) {
    result += '*';
  }
  result += domain.substring(dot);

  return result;
};
